import { Typography } from '@mui/material';
import OtherGreenhouseGasTermTarget from './OtherGreenhouseGasTermTarget';

type OtherGreenhouseGasGoalYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const OtherGreenhouseGasGoalYear = ({
  isCompletedTh,
  isCompletedEn,
}: OtherGreenhouseGasGoalYearProps) => {
  return (
    <>
      <Typography fontWeight={800} mt={2} sx={{ textDecoration: 'underline' }}>
        ปีเป้าหมาย
      </Typography>
      <Typography fontSize={12}>(โปรดระบุอย่างน้อย 1 เป้าหมาย)</Typography>
      <OtherGreenhouseGasTermTarget
        isCompletedTh={isCompletedTh}
        isCompletedEn={isCompletedEn}
        title="เป้าหมายระยะสั้น (Short-term target)"
        fieldPath="nearTermTarget"
      />
      <OtherGreenhouseGasTermTarget
        isCompletedTh={isCompletedTh}
        isCompletedEn={isCompletedEn}
        title="เป้าหมายระยะยาว (Long-term target)"
        fieldPath="longTermTarget"
      />
    </>
  );
};

export default OtherGreenhouseGasGoalYear;
